import { Component } from '@angular/core';
import { ResizeDetectionService } from 'src/app/nutrigenic/services/resize-detection.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PromotionsService } from 'src/app/nutrigenic/services/promotions/promotions.service'

@Component({
  selector: 'app-lucky-winner-banner',
  templateUrl: './lucky-winner-banner.component.html',
  styleUrls: ['./lucky-winner-banner.component.scss']
})
export class LuckyWinnerBannerComponent {
  isTablet: boolean = false;
  isMobile: boolean = false;
  isDesktop: boolean = false;

  cookieName = 'lucky-winner-already-subscribed';

  luckyWinnerSubscribePopupVisibility: boolean = false;
  luckyWinnerOrderNowPopupVisibility: boolean = false;

  promoForm: FormGroup;
  
  constructor(private sizedetection: ResizeDetectionService, private fb: FormBuilder, private router: Router, private promotionsService: PromotionsService) {}

  ngOnInit() {
    this.sizedetection.refreshSize();
    this.sizedetection.sizeCondition$.subscribe(data => {
        this.isDesktop = data.isDesktop;
        this.isTablet = data.isTablet;
        this.isMobile = data.isMobile;
    });

    this.promoForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      fullName: ['', Validators.required],
    });

    if (!localStorage.getItem(this.cookieName) && !localStorage.getItem('token')) {
        
        setTimeout(() => {
          this.luckyWinnerSubscribePopupVisibility = true;
        }, 10000);
        
    } else {
      this.luckyWinnerSubscribePopupVisibility = false;
      this.luckyWinnerOrderNowPopupVisibility = false;
    }

  }


  handlePopupClose(): void {
    this.luckyWinnerSubscribePopupVisibility = false;
    this.luckyWinnerOrderNowPopupVisibility = false;
  }

  subscribePromo(): void {
    if (this.promoForm.valid) {
      //console.log('User Subscribed to promo providing data:', this.promoForm.value);

      // remote call to backend
      this.promotionsService.participateFreeFoodYearPromotion({email: this.promoForm.value.email, fullName: this.promoForm.value.fullName}).subscribe((res:any) => {
            console.log(res.results);
        });

        localStorage.setItem(this.cookieName, "1");
        this.luckyWinnerSubscribePopupVisibility = false;
        this.luckyWinnerOrderNowPopupVisibility = true;
              
    } else {
      //console.error('Form Data Invalid');
    }
  }

  goToPlan() {
      this.luckyWinnerSubscribePopupVisibility = false;
      this.luckyWinnerOrderNowPopupVisibility = false;
      this.router.navigate(["order-flow"]);
    }
  
}
